import { getMartData } from "api/ApiCalls"
import { applyFetcherOptions } from "helpers/martHelpers"
import { type MartFetcherOptions } from "types/ApiTypes"
import type { IServerSideGetRowsRequest } from "@tokenterminal/ui/DataTable"

// Deprecated

const DATASET_TABLE = `stablecoins`

const PLAIN_SSRM_REQUEST: IServerSideGetRowsRequest = {
  startRow: 0,
  endRow: 100,
  valueCols: [],
  pivotCols: [],
  rowGroupCols: [],
  pivotMode: false,
  groupKeys: [],
  filterModel: {},
  sortModel: [],
}

const DEFAULT_SSRM_REQUEST: IServerSideGetRowsRequest = {
  ...PLAIN_SSRM_REQUEST,
  sortModel: [
    {
      sort: "desc",
      colId: "outstanding_supply_30d_change",
    },
  ],
}

type StableCoinsDataBQ = Record<string, string | number>

export async function getStableCoinsData<T = Array<StableCoinsDataBQ>>(
  body: IServerSideGetRowsRequest = DEFAULT_SSRM_REQUEST,
  opts?: MartFetcherOptions
) {
  if (opts) {
    applyFetcherOptions(body, opts)
  }
  const { data } = await getMartData<T>(DATASET_TABLE, body)

  return data
}
